<!--
 * @Author: c.k
 * @Date: 2022-07-25 10:39:30
 * @LastEditors: c.k
 * @LastEditTime: 2022-07-27 17:07:48
 * @Descripttion: 
-->
<template>
  <div class="sidebar_box">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-nav"
      mode="horizontal"
      @select="handleSelect"
      background-color="#0B2154"
      text-color="#fff"
      active-text-color="#fff"
    >
      <el-menu-item index="/">官网首页</el-menu-item>
      <el-menu-item index="/platform">平台入驻</el-menu-item>
      <el-menu-item index="/dataDeclaration">数据申报</el-menu-item>
      <el-menu-item index="/testArea">综试区</el-menu-item>
      <el-menu-item index="/navigationAffairs">政务导航</el-menu-item>
      <el-menu-item index="/dataServices">大数据服务</el-menu-item>
      <el-menu-item index="/documents">资料文档</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "/",
    };
  },
  watch: {
    $route(to, from) {
      console.log(to.path);
    },
  },
  created() {
    // console.log(this.$router.currentRoute.path);
    this.activeIndex = this.$router.currentRoute.path;
  },
  mounted() {
    console.log(this.$router);
  },

  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.$router.push(key);
    },
  },

  mounted() {},
};
</script>

<style scoped lang="less">
.el-menu-nav{
  .el-menu-item{
    font-size: 16px;
  }
}
.sidebar_box {
  width: 1200px;
  margin: 0 auto;
}
.el-menu.el-menu--horizontal {
  border: none;
}
.is-active {
  color: #fff;
  border-bottom-color: rgb(255 255 255 / 0%) !important;
  background-color: #bf1929 !important;
}
.el-menu-item {
  padding: 0;
  width: 171.4px;
  text-align: center;
}
</style>
